var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLabel)?_c('MapLabel',{attrs:{"label":_vm.name,"location":_vm.location,"visible":_vm.labelVisibility,"size":_vm.labelSize,"offset":_vm.labelOffset}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }